import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import React, { useContext, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import styled from '@emotion/styled';
import Button from '@atlaskit/button/custom-theme-button';
import { ConfluenceLogo } from '@atlaskit/logo';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { ExperienceContext, ExperienceTrackerContext } from '@atlassian/experience-tracker';
import { ExperienceReasons } from '../experience-tracker/ExperienceNames';
import { LoginToConfluenceIcon } from './LoginPageIconSVG';
var LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  font-size: medium;\n  height: 500px;\n  justify-content: space-around;\n  margin: auto;\n  position: relative;\n  text-align: center;\n"])));
var StyledLoginPageIconSVG = styled(LoginToConfluenceIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  && {\n    margin-top: ", ";\n  }\n"])), "var(--ds-space-300, 24px)");
var ParagraphLogin = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   {\n    font-size: x-large;\n    margin-top: ", ";\n  }\n"])), "var(--ds-space-300, 24px)");
var ButtonLoginToConfluenceNewTab = styled(Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  && {\n    font-weight: 500;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"])), "var(--ds-space-300, 24px)", "var(--ds-space-150, 12px)");
var StyledParagraph = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n   {\n    margin-top: ", ";\n  }\n"])), "var(--ds-space-150, 12px)");
var StyledLink = styled.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n   {\n    display: block;\n  }\n"])));
var i18n = defineMessages({
  buttonLoginToConfluenceNewTab: {
    id: 'embedded.confluence.generic-error-page.login-to-confluence-button',
    description: 'The text inside the login to Confluence button',
    defaultMessage: 'Log in to Confluence'
  },
  paragraphLogin: {
    id: 'embedded.confluence.need-to-log-in-paragraph',
    description: 'The text inside embedded confluence that tell user they need to be logged in to view this page',
    defaultMessage: 'You need to be logged in to view this page'
  },
  paragraphAlreadyLoggedIn: {
    id: 'embedded.confluence.already-logged-in-paragraph',
    description: 'The text inside embedded confluence that asks the user if they have logged in and refresh if so.',
    defaultMessage: 'Already logged in? Try refreshing.'
  },
  paragraphStillHavingTrouble: {
    id: 'embedded.confluence.still-having-trouble-paragraph',
    description: 'The text inside embedded confluence that asks the user if still having trouble and how they can enable third party cookies if so.',
    defaultMessage: 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}'
  },
  linkTroubleshootingText: {
    id: 'embedded.confluence.troubleshooting-link-text',
    description: 'the name of the placeholder {link} used in embedded.confluence.still-having-trouble-paragraph. Please translate these two as a single sentence',
    defaultMessage: 'refer to this troubleshooting guide.'
  },
  linkAriaLabel: {
    id: 'embedded.confluence.troubleshooting-link.aria-label',
    description: 'The aria label for troubleshooting link.',
    defaultMessage: 'troubleshooting guide link'
  }
});
export var ErrorScreen = function ErrorScreen(_ref) {
  var standaloneConfluenceUrl = _ref.standaloneConfluenceUrl;
  var experienceTracker = useContext(ExperienceTrackerContext);
  var experience = useContext(ExperienceContext);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  useEffect(function () {
    experienceTracker.abort({
      name: experience,
      reason: ExperienceReasons.UNABLE_TO_DISPLAY_CONTENT
    });
  }, [experience, experienceTracker]);
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "error-screen-container"
  }, /*#__PURE__*/React.createElement(ConfluenceLogo, {
    appearance: "brand",
    size: "xlarge"
  }), /*#__PURE__*/React.createElement(StyledLoginPageIconSVG, null), /*#__PURE__*/React.createElement(ParagraphLogin, null, formatMessage(i18n.paragraphLogin)), /*#__PURE__*/React.createElement(ButtonLoginToConfluenceNewTab, {
    appearance: "primary",
    "aria-label": formatMessage(i18n.buttonLoginToConfluenceNewTab),
    iconAfter: /*#__PURE__*/React.createElement(ShortcutIcon, {
      label: "",
      size: "medium"
    }),
    href: standaloneConfluenceUrl !== null && standaloneConfluenceUrl !== void 0 ? standaloneConfluenceUrl : '',
    target: "_blank"
  }, formatMessage(i18n.buttonLoginToConfluenceNewTab)), /*#__PURE__*/React.createElement(StyledParagraph, null, formatMessage(i18n.paragraphAlreadyLoggedIn)), /*#__PURE__*/React.createElement(StyledParagraph, null, formatMessage(i18n.paragraphStillHavingTrouble, {
    link: /*#__PURE__*/React.createElement(StyledLink, {
      href: LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
      target: "_blank",
      "aria-label": formatMessage(i18n.linkAriaLabel)
    }, formatMessage(i18n.linkTroubleshootingText))
  })));
};